/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useMemo } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// import Button from "@mui/material/Button";
// import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Modal component
import MDModal from "components/MDModal";
import DetallesEmpresa from "./components/DetallesEmpresa";

// Custom Pagination component
import Pagination from "components/common/pagination/Pagination";

// Context
import { useMaterialUIController } from "context";

// Data
import { empresasTableData } from "./data";

const ITEMS_PER_PAGE = 5;

function EmpresasRegistradas() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const [controller] = useMaterialUIController();
  const { searchTerm } = controller;

  const handleViewDetails = (empresa) => {
    setSelectedEmpresa(empresa);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedEmpresa(null);
  };
  
  useEffect(() => {
    // Obtenemos los datos y los establecemos en el estado
    const data = empresasTableData(handleViewDetails);
    setTableData(data);
  }, []); // El array vacío asegura que esto se ejecute solo una vez

  // Filter rows based on searchTerm
  const filteredRows = useMemo(() => {
    if (!searchTerm) {
      return tableData.rows;
    }
    const lowercasedSearchTerm = searchTerm.toLowerCase();
    return tableData.rows.filter((row) => {
      // Accedemos a los datos originales a través de row.original
      const { nombre, email, sector_empresa } = row.original || {};
      return (
        (nombre && nombre.toLowerCase().includes(lowercasedSearchTerm)) ||
        (email && email.toLowerCase().includes(lowercasedSearchTerm)) ||
        (sector_empresa && sector_empresa.toLowerCase().includes(lowercasedSearchTerm))
      );
    });
  }, [tableData.rows, searchTerm]);

  // Reset page to 1 when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // Pagination logic
  const totalItems = filteredRows.length;
  const paginatedRows = filteredRows.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Empresas Registradas
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: tableData.columns, rows: paginatedRows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <Pagination
                  itemsPerPage={ITEMS_PER_PAGE}
                  totalItems={totalItems}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Modal para mostrar detalles */}
      <MDModal
        open={modalOpen}
        onClose={handleCloseModal}
        title="Detalles de la Empresa"
        size="lg"
      >
        {selectedEmpresa && <DetallesEmpresa empresa={selectedEmpresa} />}
      </MDModal>

      <Footer />
    </DashboardLayout>
  );
}

export default EmpresasRegistradas; 